module.exports = __webpack_public_path__ + "img/60c20aa8325d47.86149716.6839e37a.png";